import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=5c84639b&scoped=true&"
import script from "./TaskProgress.vue?vue&type=script&lang=ts&"
export * from "./TaskProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84639b",
  null
  
)

export default component.exports